<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Serviços' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-grid class="ion-margin">
    <ion-row *ngIf="isAvulso">
      <ion-col>
        <h1 class="titulo-lote">{{lotes[0]['nome']}} {{'Check-in' | translate}}</h1>
        <p class="checkins">{{checkInsRealizados}}/{{qntLotesTotal}} {{'Check-in Realizados' | translate}}</p>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!isAvulso">
      <ion-col class="ion-text-center ion-margin-top titulo-retirada">
        <p>{{'Selecione os itens para retirar' | translate}}</p>
      </ion-col>
    </ion-row>

    <ion-card *ngIf="isAvulso">
      <ion-row>
        <ion-col *ngIf="qntLotes.length > 1" class="ion-margin-horizontal">
          <ion-select
            label-placement="stacked"
            cancelText="{{ 'Cancelar' | translate}}"
            okText="{{ 'Confirmar' | translate}}"
            [(ngModel)]="qntChecks"
            [interfaceOptions]="{cssClass: 'alerta-personalizado'}"
            mode="ios"
          >
            <div slot="label">{{'Check-ins restantes' | translate}}</div>
            <ng-container *ngFor="let in of qntLotes; let i = index">
              <ion-select-option *ngIf="i != 0" [value]="i"> {{i}} </ion-select-option>
            </ng-container>
          </ion-select>
        </ion-col>
      </ion-row>
    </ion-card>

    <ion-row class="border-bottom">
      <ion-col *ngIf="qntLotes.length == 1">
        <span style="font-size: 14px">{{'Todos check-ins foram realizados' | translate}}</span>
      </ion-col>

      <ion-col *ngIf="qntLotes.length > 1 && isAvulso">
        <ion-button class="btn-success" expand="block" (click)="confirmarCheck()">
          <span> {{'Confirmar Check-ins' | translate}} </span>
        </ion-button>
      </ion-col>
    </ion-row>

    <ng-container *ngIf="servicos.length">
      <div *ngIf="isAvulso" class="ion-text-center ion-margin-top titulo-retirada">
        {{'Selecione os itens para retirar' | translate}}
      </div>

      <ion-card *ngFor="let s of servicos">
        <ion-row style="margin: 8px">
          <ion-col size="2" class="alinhamento" (click)="retirarServico(s)">
            <i *ngIf="!s.data_retirada" class="fal fa-circle"></i>
            <i *ngIf="s.data_retirada" class="fal fa-check-circle" style="color: #1dbb00"></i>
          </ion-col>
          <ion-col size="8">
            <div class="ion-display-flex ion-flex-column">
              <p class="qtd-item">x{{s.quantidade}} {{s.nome}}</p>

              <span *ngIf="s.data_retirada">{{s.data_retirada | date:'dd/MM/yyyy H:mm:s'}}</span>
              <span *ngIf="isAvulso && !s.data_retirada">{{'Não Retirado' | translate}}</span>
            </div>
          </ion-col>
        </ion-row>
      </ion-card>

      <ion-row *ngIf="!hideBtn && loaded">
        <ion-col size="12">
          <ion-button expand="block" class="btn-default" (click)="retirarTodosServicos()">
            {{'Retirar Todos' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ng-container>
  </ion-grid>
</ion-content>
